import { availableTimes as defaultAvailableTimes } from 'components/practice/Settings/components/Calendar/components/AvailableTime/lib';

const formInitialValues = (practice) => {
  return {
    ...practice,
    headerPhoto: practice?.header_photo || null,
    dbaName: practice?.dba_name || '',
    address: {
      id: practice?.practiceAddress?.id || null,
      address_ln_1: practice?.practiceAddress?.address_ln_1 || '',
      address_ln_2: practice?.practiceAddress?.address_ln_2 || '',
      city: practice?.practiceAddress?.city || '',
      state: practice?.practiceAddress?.state || '',
      zip: practice?.practiceAddress?.zip || ''
    },
    displaySettings: practice?.display_settings || null,
    stickyNotesAlert: practice?.display_settings?.sticky_notes?.alert || false,
    surchargeEnabled: practice?.surcharge_enabled || false,
    surchargeAmount: (practice?.surcharge_percentage ?? 0) * 100,
    batchTime: practice?.display_settings?.billing?.payment?.batch_time || '09:00',
    availableTimes: practice?.available_times || defaultAvailableTimes,
    timezone: practice?.timezone || null
  };
};

export default formInitialValues;
